import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanActivateFn,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { PromptDialogService } from '../services/prompt-dialog.service';
import { FeatureFlags, LaunchDarklyService } from '../services/launch-darkly.service';

async function performCheck(featureFlag?: FeatureFlags): Promise<boolean> {
  const router = inject(Router);
  const authService = inject(LaunchDarklyService);
  const promptDialog = inject(PromptDialogService);
  if (!featureFlag) {
    console.error('Feature flag directive called, but no feature flag provided');
    return true;
  }

  const isEnabled = await authService.isFeatureEnabled(featureFlag);
  if (isEnabled) {
    return true;
  }

  await promptDialog.openPrompt(
    'No Access',
    'This feature is not available for the current user. Please try a different user.',
    'Ok',
  );
  router.navigate(['/']);
  return false;
}

@Injectable()
export class FeatureFlagGuard implements CanActivate, CanLoad, CanActivateChild {
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return await performCheck(route.data.featureFlag);
  }

  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    return await performCheck(route.data.featureFlag);
  }

  async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return await performCheck(route.data.featureFlag);
  }
}

export const featureFlagGuard = (featureFlag: FeatureFlags): CanActivateFn => {
  return () => performCheck(featureFlag);
};
